import { useQuery } from 'react-query';

import onQueryError from 'helpers/queryError';
import APIUtil from 'api/apiUtil';
import { SessionDetails } from 'types/auth';
import { AxiosError } from 'axios';

const api = new APIUtil();

interface GetSessionDetailsProps {
  companyId: number;
}

export const getSessionDetails = ({ companyId }: GetSessionDetailsProps) => {
  return api.get(`user/session?companyId=${companyId}`);
};

interface UseSessionDetailsProps extends GetSessionDetailsProps {
  enabled?: boolean;
  onSuccess?: (data: any) => void;
}

export const useSessionDetails = ({
  companyId,
  enabled = true,
  onSuccess
}: UseSessionDetailsProps) => {
  return useQuery<{ data: SessionDetails }, AxiosError, SessionDetails>({
    queryKey: [
      'SESSION_DETAILS',
      {
        companyId
      }
    ],
    queryFn: () => getSessionDetails({ companyId }),
    enabled,
    onError: error => onQueryError(error),
    select: data => data.data,
    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
};
